class AttractionSearchBox {
  constructor(t, options = {}) {
    options = options || {};
    this.specificProductId = options.specificProductId;

    this.target = t;
    this.form = this.target.querySelector("form");

    this.productLargeSelect = this.target.querySelector("[data-attraction-filter=products] [data-select-type=list]");
    this.productOptions = [];
    this.productSelect = {};

    this.departurePointLargeSelect = this.target.querySelector("[data-attraction-filter=departurePoints] [data-select-type=list]");
    this.departureOptions = [];

    this.form.addEventListener('submit', this.submit.bind(this));
  }

  createPayload() {
    let passengerTypes = this.target.querySelectorAll('[name=passengerType]');
    let dateValues = searchBoxes.dateTimes.getValues(this.getDateTimeContainer());

    return Promise.resolve({
      productId: parseInt(this.form.productId.value),
      departureId: parseInt(this.form.departureId.value),
      outboundDate: dateValues.date,
      outboundHour: dateValues.hours,
      outboundMinute: dateValues.minutes,
      passengers: [].filter.call(passengerTypes, (element) => element.value !== "0")
        .map(element => ({ id: element.dataset.id, value: element.value }))
    });
  }

  ValidateInfant(errors) {
    const infantId = document.querySelector("[data-infant-id]")?.dataset.infantId;
    const adultIds = document.querySelector("[data-adult-ids]")?.dataset.adultIds;

    if (!infantId || !adultIds) {
      return;
    }

    const infantAmount = searchBoxes.passengers.getSelectedForTypeId(this.form, infantId).value;
    const adultAmount = searchBoxes.passengers.getSelectedForTypeArrayId(this.form, adultIds.split(','))
      .map(passengerType => passengerType.value)
      .reduce((a, b) => parseInt(a) + parseInt(b), 0);

    if (infantAmount > 0 && adultAmount <= 0) {
      const message = this.form.dataset.infantValidationMessage;
      errors.push(message);
    }
  }

  ValidatePayload(search) {
    let errors = [];

    this.ValidateInfant(errors);

    let outbound = searchBoxes.dateTimes.getValues(this.getDateTimeContainer()).parsedDate();

    if (!outbound) {
      errors.push("The departure date is invalid");
    } else if (outbound.isBefore(new dayjs())) {
      errors.push("The outbound date cannot be before today's date.");
    }

    if (!search.passengers.length) {
      errors.push("Please select at least 1 passenger.");
    }

    return errors;
  }

  CheckValidation() {
    this.createPayload()
      .then(payload => this.ValidatePayload(payload))
      .then(errors => this.ShowErrors(errors));
  }

  ShowErrors(errors) {
    let area = this.target.querySelector(".search-form__validation-area");

    area.innerHTML = "";
    errors.forEach(error => {
      let message = document.createElement("p");
      message.innerText = error;
      area.appendChild(message);
    });

    area.style.display = area.innerHTML === "" ? "none" : "block";

    return errors;
  }

  submit() {
    event.preventDefault();

    this.createPayload()
      .then(payload => {
        localStorage.currentSearch = JSON.stringify(payload);
        localStorage.currentSearchType = "attractionresults";

        this.form.searchPayload.value = JSON.stringify(payload);

        return payload;
      })
      .then(payload => this.ValidatePayload(payload))
      .then(errors => this.ShowErrors(errors))
      .then(errors => {
        if (!errors.length) {
          Utilities.ShowLoader();
          this.form.submit();
        }
      });
  }

  get(uri) {
    return window.fetch(uri)
      .then(response => response.json());
  }

  bindProducts(products, selectedId = 0) {
    return Promise.resolve(typeof selectedId === "undefined" ? parseInt(this.form.productId.value) : selectedId)
      .then(id => products.filter(x => x.Id == id).length ? id : products.length ? products[0].Id : 0)
      .then(id => {
        return {
          keyValues: products.map(x => {
            return {
              key: x.Id,
              value: x.Name
            };
          }),
          selectedId: id
        };
      })
      .then(data => searchBoxes.formWrappers.bindList(this.form.productId, data.keyValues, data.selectedId));
  }

  bindDepartureLocations(locations, selectedId = 0) {
    return Promise.resolve(typeof selectedId === "undefined" ? parseInt(this.form.departureId.value) : selectedId)
      .then(id => locations.filter(x => x.Id == id).length ? id : locations.length ? locations[0].Id : 0)
      .then(id => {
        return {
          keyValues: locations.map(x => {
            return {
              key: x.Id,
              value: x.Name
            };
          }),
          selectedId: id
        };
      })
      .then(data => searchBoxes.formWrappers.bindList(this.form.departureId, data.keyValues, data.selectedId));
  }

  refreshDepartureOptions(selectedDepartureId = 0) {
    return Promise.resolve(parseInt(this.form.productId.value))
      .then(productId => this.productOptions.filter(x => x.Id == productId)[0].LocationId)
      .then(destinationId => this.departurePoints.filter(x => x.Id != destinationId))
      .then(locations => this.bindDepartureLocations(locations, selectedDepartureId));
  }

  loadProducts() {
    return this.get("/Umbraco/Api/DataApi/Products")
      .then(products => {
        if (this.specificProductId) {
          var filtered = products.filter(x => x.Id == this.specificProductId);

          if (filtered.length == 1) {
            return filtered;
          }
        }

        return products;
      })
      .then(products => {
        this.productOptions = products;

        return this.bindProducts(products)
          .then(_ => {
            if (products.length == 1) {
              this.form.productId.disabled = true;
              this.productLargeSelect.querySelector(".large-select__icon").style.display = "none";
              this.productLargeSelect.querySelector(".large-select__value").innerHTML =
                products[0].Name;
            } else {
              this.productSelect = new LargeSelectList(this.productLargeSelect);
            }
          });
      });
  }

  loadDeparturePoints() {
    return this.get("/Umbraco/Api/DataApi/departurepoints")
      .then(data => {
        this.departurePoints = data;

        return this.bindDepartureLocations(data)
          .then(_ => {
            this.departurePointSelect = new LargeSelectList(this.departurePointLargeSelect);
          });
      });
  }

  getDateTimeContainer() {
    return this.form.querySelector("[data-attraction-filter=travelDate]");
  }

  loadPreferredDate() {
    var productId = parseInt(this.form.productId.value);
    var departurePointId = parseInt(this.form.departureId.value);

    var date = searchBoxes.dateTimes.getValues(this.getDateTimeContainer()).parsedDate() || new dayjs();

    return this.get(`/Umbraco/Api/DataApi/ProductDefaultDate?productId=${productId}&departurePointId=${departurePointId}&selectedDateTime=${date.toISOString()}`)
      .then(preferredDateTime => {
        if (preferredDateTime) {
          this.setDateTime(preferredDateTime);
        }
      });
  }

  Initialise() {
    return Promise.all([
      this.loadProducts(),
      this.loadDeparturePoints()
    ])
      .then(_ => this.refreshDepartureOptions())
      .then(_ => {
        this.renderDateTimePicker(this.getDateTimeContainer());

        return this.loadPreferredDate();
      })
      .then(_ => {
        this.paxSelect = new LargeSelectPax(this.target.querySelector("[data-attraction-filter=pax] [data-select-type=pax]"));

        this.target.querySelector('[data-loader]').remove();
        this.target.querySelector('form').style.display = '';

        this.form.productId.addEventListener('change',
          () => {
            this.refreshDepartureOptions()
              .then(_ => this.loadPreferredDate());
          });
        this.form.departureId.addEventListener('change',
          () => {
            this.loadPreferredDate();
          });
        this.form.outboundDate.addEventListener('change', () => {
          this.loadPreferredDate();
        });

        SearchBoxValidationCallback.addListener("Product",
          () => {
            this.CheckValidation();
          });
      });
  }

  bind(model) {
    return this.bindProducts(this.productOptions, model.productId)
      .then(_ => this.refreshDepartureOptions(model.departureId))
      .then(_ => this.setDateTime(searchBoxes.dateTimes.buildUnixString(model.outboundDate, model.outboundHour, model.outboundMinute)))
      .then(_ => searchBoxes.passengers.setSelected(this.form, model.passengers));
  }

  setDateTime(d) {
    if (typeof d === 'undefined') {
      d = new Date();
    }

    searchBoxes.dateTimes.setDateTime(this.getDateTimeContainer(), new dayjs(d));
  }

  renderDateTimePicker(container) {
    let datePicker = container.querySelector("[data-select-type='datetime-date']");
    let timePicker = container.querySelector("[data-select-type='datetime-time']");

    return [
      new LargeSelectDate(datePicker, datePicker.closest('.date-time-picker')),
      new LargeSelectTime(timePicker, timePicker.closest('.date-time-picker'))
    ];
  }
};

function bookNowProductSearch(target, productId) {
  let searchBox = new AttractionSearchBox(target,
    {
      specificProductId: productId
    });
  return searchBox.Initialise();
}
